export default __webpack_public_path__ + "assets/icons/solidArrow.7352837e.svg";